var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('one-cms-grid-render',{class:_vm.mainComponentClass,attrs:{"element":_vm.content,"available-components":_vm.availableComponents}})}
var staticRenderFns = []

export { render, staticRenderFns }